import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const ServiceCarousel = ({ service }) => {
  return (
    <div className="w-full lg:w-1/2">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        // navigation
        pagination={{ clickable: true }}
        loop={true}
        spaceBetween={20}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        breakpoints={{
          320: { slidesPerView: 1 },     // Mobile
          640: { slidesPerView: 1 },     // Small tablets
          768: { slidesPerView: 1 },     // Medium tablets
          1024: { slidesPerView: 1 },    // Desktop
          1280: { slidesPerView: 1 },    // Large screens
        }}
      >
        {(service.images || [service.img]).map((image, idx) => (
          <SwiperSlide key={idx}>
            <motion.img
              src={image}         
               loading="lazy"
              alt={`${service.title} ${idx + 1}`}
              className="object-contain w-full h-64 sm:h-72 md:h-80 lg:h-96 rounded-2xl shadow-lg cursor-pointer"
              whileHover={{ scale: 1.05, rotate: 1 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ServiceCarousel;
